import { render, staticRenderFns } from "./FieldWorkplace2Write.vue?vue&type=template&id=3b09f59c&scoped=true"
import script from "./FieldWorkplace2Write.vue?vue&type=script&lang=js"
export * from "./FieldWorkplace2Write.vue?vue&type=script&lang=js"
import style0 from "./FieldWorkplace2Write.vue?vue&type=style&index=0&id=3b09f59c&prod&scoped=true&lang=scss"
import style1 from "./FieldWorkplace2Write.vue?vue&type=style&index=1&id=3b09f59c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b09f59c",
  null
  
)

export default component.exports